import { BUSINESS_PLAN_TYPES, IBusinessToolType } from 'constants/businessPlan';
import { IUnitedSections } from 'constants/businessToolSections';
import { FOR_BANK_SECTIONS } from 'constants/businessToolSections/forBank';
import { FOR_INVESTORS_SECTIONS } from 'constants/businessToolSections/forInvestors';
import { ONE_PAGE_SECTIONS } from 'constants/businessToolSections/onePage';
import { ONE_PAGE_SHORT_SECTIONS } from 'constants/businessToolSections/onePageShort';

import { ILoadingStates } from './business-tool-ai-context';

export const AI_GENERATION_SECTIONS: Record<IBusinessToolType, IUnitedSections[]> = {
  [BUSINESS_PLAN_TYPES.FOR_BANK]: [
    FOR_BANK_SECTIONS.OVERVIEW,
    FOR_BANK_SECTIONS.EXECUTIVE_SUMMARY,
    FOR_BANK_SECTIONS.ABOUT_COMPANY,
    FOR_BANK_SECTIONS.PRODUCTS_AND_SERVICES,
    FOR_BANK_SECTIONS.MARKET_ANALYSIS,
    FOR_BANK_SECTIONS.MARKETING_AND_SALES,
    FOR_BANK_SECTIONS.BUSINESS_OPERATIONS,
    FOR_BANK_SECTIONS.MANAGEMENT_AND_ORGANIZATION,
    FOR_BANK_SECTIONS.RAISING_AND_ALLOCATING_FUNDS,
    FOR_BANK_SECTIONS.LEGAL_FRAMEWORKS_AND_RISKS,
    FOR_BANK_SECTIONS.FINANCIAL_PLAN,
  ],
  [BUSINESS_PLAN_TYPES.FOR_INVESTORS]: [
    FOR_INVESTORS_SECTIONS.OVERVIEW,
    FOR_INVESTORS_SECTIONS.EXECUTIVE_SUMMARY,
    FOR_INVESTORS_SECTIONS.COMPANY_AND_PROJECT,
    FOR_INVESTORS_SECTIONS.MARKET_ANALYSIS,
    FOR_INVESTORS_SECTIONS.MARKETING_AND_SALES,
    FOR_INVESTORS_SECTIONS.BUSINESS_OPERATIONS,
    FOR_INVESTORS_SECTIONS.MANAGEMENT_AND_ORGANIZATION,
    FOR_INVESTORS_SECTIONS.RAISING_AND_ALLOCATING_FUNDS,
    FOR_BANK_SECTIONS.FINANCIAL_PLAN,
  ],
  [BUSINESS_PLAN_TYPES.ONE_PAGE]: [
    ONE_PAGE_SECTIONS.ABOUT_THE_COMPANY,
    ONE_PAGE_SECTIONS.ABOUT_THE_PROJECT,
    ONE_PAGE_SECTIONS.PRODUCTS_SERVICES,
    ONE_PAGE_SECTIONS.MARKET_AND_SALES,
    ONE_PAGE_SECTIONS.TEAM,
    ONE_PAGE_SECTIONS.FINANCIAL_PROJECTIONS,
    ONE_PAGE_SECTIONS.FINANCING_NEEDS,
    ONE_PAGE_SECTIONS.IMPLEMENTATION_PLAN,
  ],
  [BUSINESS_PLAN_TYPES.ONE_PAGE_SHORT]: [ONE_PAGE_SHORT_SECTIONS.SHORT],
};

export const getDefaultLoadingStates = (
  planType: IBusinessToolType = BUSINESS_PLAN_TYPES.ONE_PAGE,
  isLoading = true,
): ILoadingStates => {
  const sections = AI_GENERATION_SECTIONS[planType];

  return sections.reduce((acc: ILoadingStates, key) => {
    acc[key] = isLoading;
    return acc;
  }, {} as ILoadingStates);
};
